import type { AutocompleteConfigurableFilter } from '@openx/components-filters/lib/FiltersBar/types';
import regionsData from '../data/regionCountryData.json';

export const getFormattedCountryOptions = (): AutocompleteConfigurableFilter<unknown>['options'] => {
  return Object.values(regionsData.regions)
    .flatMap(region => region.countries)
    .sort((countryA, countryB) => countryA.name.localeCompare(countryB.name, 'en', { sensitivity: 'base' }));
};
